<template>
  <div class="mall-order-payment">
    <MallSubTitle :label="'결제 정보'" />
    <div class="mall-order-payment__row">
      <span class="mall-order-payment__label">상품 금액</span>
      <span class="mall-order-payment__value">{{ formatPrice(productAmount) }}</span>
    </div>
    <div v-if="discountAmount > 0" class="mall-order-payment__row">
      <span class="mall-order-payment__label">할인</span>
      <span class="mall-order-payment__value mall-order-payment__value--discount">-{{ formatPrice(discountAmount) }}</span>
    </div>
    <div v-if="shippingFee !== null" class="mall-order-payment__row">
      <span class="mall-order-payment__label">배송비</span>
      <span class="mall-order-payment__value">{{ shippingFee > 0 ? formatPrice(shippingFee) : '무료' }}</span>
    </div>
    <div class="mall-order-payment__divider"></div>
    <div class="mall-order-payment__row mall-order-payment__row--total">
      <span class="mall-order-payment__label">총 결제금액</span>
      <span class="mall-order-payment__value">{{ formatPrice(totalAmount) }}</span>
    </div>
  </div>
</template>

<script>
import convert from '@/utilities/convert.js'
import MallSubTitle from '@/components/new/atoms/MallSubTitle.vue'

export default {
  name: 'MallOrderPayment',
  components: {
    MallSubTitle,
  },
  props: {
    productAmount: {
      type: Number,
      default: 0,
    },
    // 0이면 할인 항목 미노출
    discountAmount: {
      type: Number,
      default: 0,
    },
    // 0이면 '무료', null이면 배송비 항목 미노출
    shippingFee: {
      type: Number,
      default: 0,
    },
    totalAmount: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    formatPrice(price) {
      return convert.setComma(price) + '원'
    },
  },
}
</script>

<style scoped>
.mall-order-payment {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mall-order-payment__row {
  display: flex;
  padding: 0 4px;
  align-items: center;
  gap: 10px;
  font-family: Pretendard;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
}

.mall-order-payment__row--total {
  font-size: var(--font-size-lg);
}

.mall-order-payment__label {
  color: #6B7684;
  white-space: nowrap;
}

.mall-order-payment__value {
  flex: 1;
  min-width: 0;
  color: var(--color-text-main);
  text-align: right;
}

.mall-order-payment__value--discount {
  color: #F04452;
}

.mall-order-payment__divider {
  height: 1px;
  background: #F2F4F6;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/MallOrderPayment.vue